import React, { useState, useRef, useEffect } from 'react';
import { Layers } from 'lucide-react';
import {
  Checkbox,
  CheckboxLabel,
  DropdownButton,
  DropdownContainer,
  DropdownContent,
  DropdownTitle,
} from './overlay.style';

const OverlayDropdown = ({
  onOverlayChange,
  overlayOptions,
  isDisabled,
  selectedOverlays = [], // This should come from Zustand store
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Handle click outside to close dropdown
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    if (!isDisabled) {
      setIsOpen(!isOpen);
    }
  };

  const handleCheckboxChange = (overlayId) => {
    if (isDisabled) return;

    // Create updated selection based on current selectedOverlays prop
    const updatedSelection = selectedOverlays.includes(overlayId)
      ? selectedOverlays.filter((item) => item !== overlayId)
      : [...selectedOverlays, overlayId];

    // Call the parent's onChange handler
    onOverlayChange(updatedSelection);
  };

  const handleKeyPress = (event) => {
    if (isDisabled) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleDropdown();
    }
    if (event.key === 'Escape') {
      setIsOpen(false);
    }
  };

  const handleCheckboxKeyPress = (event, overlayId) => {
    if (isDisabled) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleCheckboxChange(overlayId);
    }
  };

  return (
    <DropdownContainer ref={dropdownRef}>
      <DropdownButton
        onClick={toggleDropdown}
        onKeyPress={handleKeyPress}
        aria-expanded={isOpen}
        aria-haspopup="true"
        aria-label="Toggle overlay options"
        disabled={isDisabled}
        tabIndex={isDisabled ? -1 : 0}
        className="add_overlay"
      >
        <Layers size={20} />
        <span>Add overlays {selectedOverlays.length > 0 && `(${selectedOverlays.length})`}</span>
      </DropdownButton>

      <DropdownContent isOpen={isOpen} role="menu" aria-label="Council Planning Overlay options">
        <DropdownTitle disabled={isDisabled}>Council Planning Overlays</DropdownTitle>

        {overlayOptions.map((overlay) => (
          <CheckboxLabel key={overlay.overlayId} disabled={isDisabled} role="menuitem">
            <Checkbox
              type="checkbox"
              checked={selectedOverlays.includes(overlay.overlayId)}
              onChange={() => handleCheckboxChange(overlay.overlayId)}
              onKeyPress={(e) => handleCheckboxKeyPress(e, overlay.overlayId)}
              aria-label={overlay.overlayName}
              disabled={isDisabled}
              tabIndex={isDisabled ? -1 : 0}
            />
            <span>{overlay.overlayName}</span>
          </CheckboxLabel>
        ))}

        {overlayOptions.length === 0 && !isDisabled && (
          <div style={{ padding: '8px 12px', color: '#666', fontStyle: 'italic' }}>
            No overlays available
          </div>
        )}
      </DropdownContent>
    </DropdownContainer>
  );
};

export default OverlayDropdown;
